import dummyImage from "assets/images/common/others/minorImage.png";
import { FC } from "react";
import editProfilePicUser from "assets/images/common/others/editProfileUSer.png";
import { concatPathWithBackendUrl } from "utils/helpers/urlHelper";

interface Props {
  user: any;
}

const Overview: FC<Props> = ({ user }) => {
  const { profiles = {} } = user || {};
  const { host = {} } = profiles;
  return (
    <div className="mt-8">
      <div className="bg-white border-[0.3px] border-mediumGrayBorder rounded-lg p-8">
        <h1 className="text-base font-bold text-primaryText">
          Business Information
        </h1>
        <div className="mt-8 flex flex-wrap justify-between items-center gap-4">
          <div className="flex flex-col gap-6">
            <span className="text-sm font-semibold text-captionText">
              Business Name
            </span>
            <span className="text-xs text-tertiaryText capitalize">
              {host.businessName ?? "-"}
            </span>
          </div>
          <div className="flex flex-col gap-6">
            <span className="text-sm font-semibold text-captionText">
              Business Email
            </span>
            <span className="text-xs text-tertiaryText">
              {host.businessEmail ?? "-"}
            </span>
          </div>
          <div className="flex flex-col gap-6">
            <span className="text-sm font-semibold text-captionText">
              Phone Number
            </span>
            <span className="text-xs text-tertiaryText">
              {host.businessPhoneNumber ?? "-"}
            </span>
          </div>
          <div className="flex flex-col gap-6">
            <span className="text-sm font-semibold text-captionText">
              Business Website
            </span>
            <span className="text-xs text-tertiaryText">
              {host.businessWebsite ?? "-"}
            </span>
          </div>
        </div>
      </div>

      <div className="bg-white border-[0.3px] border-mediumGrayBorder rounded-lg p-8 my-6">
        <h1 className="text-base font-bold text-primaryText">Details</h1>
        <div className="mt-8 flex flex-wrap justify-between gap-4">
          <div className="flex flex-col gap-6 max-w-[200px]">
            <span className="text-sm font-semibold text-captionText max-w-[200px">
              Mission
            </span>
            <span className="text-xs text-tertiaryText">
              {host.missionStatement ?? "-"}
            </span>
          </div>
          <div className="flex flex-col gap-6 max-w-[250px]">
            <span className="text-sm font-semibold text-captionText">
              About
            </span>
            <span className="text-xs text-tertiaryText">
              {host.about ?? "-"}
            </span>
          </div>
          <div className="flex flex-col gap-6 max-w-[250px">
            <span className="text-sm font-semibold text-captionText">
              Industry
            </span>
            <span className="text-xs text-tertiaryText">

              {host?.industry
                ? host.industry
                  .toLowerCase()
                  .split('_')
                  .map(word => word.charAt(0).toUpperCase() + word.slice(1))
                  .join(' ')
                : '-'}
            </span>
          </div>
          <div className="flex flex-col gap-6 max-w-[200px">
            <span className="text-sm font-semibold text-captionText">City</span>
            <span className="text-xs text-tertiaryText">
              {host.city ?? "-"}
            </span>
          </div>
          <div className="flex flex-col gap-6 max-w-[200px">
            <span className="text-sm font-semibold text-captionText">
              State
            </span>
            <span className="text-xs text-tertiaryText">
              {host.state ?? "-"}
            </span>
          </div>
          <div className="flex flex-col gap-6 max-w-[200px">
            <span className="text-sm font-semibold text-captionText">
              Zip Code
            </span>
            <span className="text-xs text-tertiaryText">
              {host.zipCode ?? "-"}
            </span>
          </div>
        </div>
      </div>

      <div className="bg-white border-[0.3px] border-mediumGrayBorder rounded-lg p-8 my-6">
        <h1 className="text-base font-bold text-primaryText">
          Drivers License
        </h1>
        <div className="mt-8 flex flex-wrap sm:gap-60 items-start gap-4">
          {/* <div className="flex flex-col gap-6">
            <span className="text-sm font-semibold text-captionText">
              Drivers Lisense
            </span>
            <span className="text-xs text-tertiaryText">{host.zipCode ?? "-"}</span>
          </div> */}
          <div className="flex flex-col gap-6">
            <span className="text-sm font-semibold text-captionText">
              Driver License or State ID
            </span>
            <div className="flex gap-3 flex-wrap ">
              <span>
                <img
                  className="w-[152px] h-[103px] border-2 border-mediumGrayBorder rounded-lg "
                  src={
                    host?.driverLicenseFrontPicUrl?.fileDownloadUri
                      ? concatPathWithBackendUrl(
                        host?.driverLicenseFrontPicUrl?.fileDownloadUri
                      )
                      : editProfilePicUser
                  }
                  alt="FrontSideImage"
                />
              </span>
              <span>
                <img
                  className="w-[152px] h-[103px] border-2 border-mediumGrayBorder rounded-lg "
                  src={
                    host?.driverLicenseBackPicUrl?.fileDownloadUri
                      ? concatPathWithBackendUrl(
                        host?.driverLicenseBackPicUrl?.fileDownloadUri
                      )
                      : editProfilePicUser
                  }
                  alt="BackSideImage"
                />
              </span>
            </div>
          </div>
        </div>
      </div>

      {/* <div className="bg-white border-[0.3px] border-mediumGrayBorder rounded-lg p-8 my-6">
        <h1 className="text-base font-bold text-primaryText">Referral</h1>
        <div className="mt-8 flex flex-wrap sm:gap-60 items-center gap-4">
          <div className="flex flex-col gap-6">
            <span className="flex gap-3 items-center">
              <img
                className="w-10 h-10 rounded-full"
                src={dummyImage}
                alt="dummyImage"
              />
              <p className="text-base font-bold text-primaryText">
                Bertha Valdez
              </p>
            </span>
            <span className="text-xs text-tertiaryText">ID: HM-2122222</span>
          </div>
        </div>
      </div> */}
    </div>
  );
};

export default Overview;
